import { render } from "./PaywallCycle.vue?vue&type=template&id=0a6b354f&scoped=true"
const script = {}

import "./PaywallCycle.vue?vue&type=style&index=0&id=0a6b354f&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6b354f"]])

export default __exports__